(function ($, Drupal, drupalSettings, once) {
  Drupal.behaviors.lang = {
    attach: function (context, settings) {
      once("lang", "ul.language-switcher-language-url", context).forEach(function (element) {
        var container = $(element);

        function langfunction() {
          var activeLang = container.find("li.is-active a").text();

          // create span with active lang
          container.parent().prepend('<span class="label">' + activeLang + '<svg class="angle-down" viewBox="0 0 320 512"><use xlink:href="#angle-down"></use></svg></span>');

          // hide  active lang in ul
          container.find("li.is-active").remove();

          //show ul
          container
            .parent()
            .find(".label")
            .on("click", function (e) {
              e.stopPropagation();
              container.slideToggle(300);
            });
        }
        setTimeout(langfunction, 1);

        //hide ul
        $(document).on("click", function (e) {
          container.slideUp(300);
        });

        $(document).scroll(function () {
          if ($(document).scrollTop() > 60) {
            container.slideUp(300);
            container.parent().find(".label").find(".fas").removeClass("fa-angle-up");
            container.parent().find(".label").find(".fas").addClass("fa-angle-down");
          }
        });
      });
    },
  };
})(jQuery, Drupal, drupalSettings, once);
